import PasswordField from '@common/components/PasswordField/PasswordField';
import { LoginQueryArgs } from '@features/authentication';
import { Button, Text, TextField, Theme } from '@radix-ui/themes';
import { Form } from 'radix-ui';
import styles from './Login.module.css';
import { useTranslation } from 'react-i18next';

interface LoginFormProps {
    handleSubmit: (credentials: LoginQueryArgs) => void;
    isLoading: boolean;
}

export const LoginUI = ({ handleSubmit, isLoading }: LoginFormProps) => {
    const { t } = useTranslation('login');

    const onValidSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const email = formData.get('email') as string;
        const password = formData.get('password') as string;

        handleSubmit({ username: email, password });
    };

    return (
        <Form.Root className={styles.formRoot} onSubmit={onValidSubmit}>
            <Theme accentColor='gray'>
                <Form.Field name='email'>
                    <Form.Message match={'valueMissing'}>
                        <Text color='red'>{t('missing.email')}</Text>
                    </Form.Message>

                    <Form.Control asChild>
                        <TextField.Root
                            className={styles.textField}
                            type='email'
                            placeholder={t('placeholder.email')}
                            autoComplete='email'
                            size={'3'}
                            required
                        />
                    </Form.Control>
                </Form.Field>

                <Form.Field name='password'>
                    <Form.Message match={'valueMissing'}>
                        <Text color='red'>{t('missing.password')}</Text>
                    </Form.Message>
                    <Form.Control asChild>
                        <PasswordField
                            className={styles.textField}
                            type='password'
                            placeholder={t('placeholder.password')}
                            size={'3'}
                            required
                        />
                    </Form.Control>
                </Form.Field>
            </Theme>

            <Form.Submit asChild>
                <Button
                    className={styles.loginButton}
                    type='submit'
                    size={'3'}
                    loading={isLoading}
                >
                    {t('button')}
                </Button>
            </Form.Submit>
        </Form.Root>
    );
};
